import { Component, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import {
    DataService,
    FormInputComponent,
    ModalService,
    NotificationService,
    SharedModule,
} from '@vendure/admin-ui/core'
import { StringCustomFieldConfig } from '@vendure/core'
import { EMPTY, Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'

import { ProductStateSelectDialogComponent } from '../product-state-select-dialog/product-state-select-dialog.component'
import { ProductStateDataService } from '../providers/product-state-data.service'

@Component({
    selector: 'product-state-field',
    templateUrl: './product-state-field.component.html',
    styleUrls: ['./product-state-field.component.scss'],
    imports: [SharedModule],
    standalone: true,
})
export class ProductStateFieldComponent implements FormInputComponent<StringCustomFieldConfig>, OnInit {
    readonly: boolean
    nextStates$: Observable<string[]>
    config: StringCustomFieldConfig
    entityId: string

    formControl: FormControl

    constructor(
        private dataService: DataService,
        private productStateDataService: ProductStateDataService,
        private modalService: ModalService,
        private route: ActivatedRoute,
        private notificationService: NotificationService,
    ) {}

    async manuallyTransitionToState() {
        return this.modalService
            .fromComponent(ProductStateSelectDialogComponent, {
                locals: {
                    nextStates: this.nextStates$,
                    cancellable: true,
                    message:
                        'Manually transition the product to another state. Note that order states are governed by rules which may prevent certain transitions.',
                },
                closable: true,
                size: 'md',
            })
            .pipe(switchMap(result => (result ? this.transitionToState(this.entityId, result) : EMPTY)))
            .subscribe(transitioned => {
                if (transitioned) {
                    // The transition is already persisted server-side, so reload to pick up the new
                    // state. Only on success: reloading on a rejected transition would wipe the
                    // error notification before the user gets to see it.
                    window.location.reload()
                }
            })
    }
    private transitionToState(productId: string, state: string): Observable<boolean> {
        return this.productStateDataService.transitionToState(productId, state).pipe(
            map(({ transitionProductToState }) => {
                if (transitionProductToState?.__typename === 'ProductStateTransitionError') {
                    this.notificationService.error(transitionProductToState.transitionError)
                    return false
                }
                return true
            }),
        )
    }

    ngOnInit() {
        this.nextStates$ = this.route.data.pipe(
            switchMap(data => data.detail.entity),
            switchMap((entity: any) => {
                if (entity) {
                    this.entityId = entity.id
                    return this.productStateDataService.getNextStates(entity.id as string).mapStream(data => {
                        return data.nextProductStates
                    })
                }
                this.formControl.setValue('Created')
                return of([])
            }),
        )
        this.nextStates$.subscribe()
    }
}
